<style lang="scss" scoped>
.slider-label {
    font-size: 2rem;
    font-weight: 600;
}

::v-deep .vue-slider-process {
    background-color: var(--accent);
}
::v-deep .vue-slider-dot-tooltip-inner {
    background-color: var(--accent);
    border-color: var(--accent);
}
::v-deep .vue-slider-dot-handle-focus {
    box-shadow: 0px 0px 1px 2px rgba(243, 146, 37, 0.36);
}

.increase,
.decrease {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}
</style>

<template>
    <div class="popup px-16 pt-24 p-md-24 p-lg-56" ref="fixBottom">
        <div class="close" @click="$emit('close')"></div>
        <h2 class="mb-16 mb-md-32">{{ translations.participant_amount_popup.title }}</h2>
        <p class="mb-32">{{ translations.participant_amount_popup.description }}</p>

        <div class="d-flex align-items-center format-row mb-32">
            <a class="mr-24" @click.prevent="setFormat('exact')" :class="{'active': format === 'exact', 'pl-0': format !== 'exact'}">{{ translations.participant_amount_popup.exact_amount }}</a>
            <a @click.prevent="setFormat('estimate')" :class="{'active': format === 'estimate'}">{{ translations.participant_amount_popup.estimation }}</a>
        </div>

        <div class="mb-32">
            <template v-if="format === 'exact'">
                <div class="number-wrapper d-flex justify-content-start align-items-center">
                    <span class="decrease mr-16" @click="decreaseParticipants">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                            <path fill="#efefef" d="M5 10A5 5 0 105 0a5 5 0 000 10z" />
                            <path d="M7.1 4.6a.4.4 0 01.08.792L7.1 5.4H2.9a.4.4 0 01-.08-.792L2.9 4.6z" />
                        </svg>
                    </span>
                    <ValidationProvider ref="provider" vid="amount_of_persons" class="w-100" :name="translations.participant_amount_popup.amount_of_persons" rules="required|integer|min:1" tag="div">
                        <input type="number" id="amount_of_persons" min="1" name="amount_of_persons" class="text-center" v-model="exact_value">
                    </ValidationProvider>
                    <span class="increase ml-16" @click="increaseParticipants">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
                            <path fill="#efefef" d="M5 10A5 5 0 105 0a5 5 0 000 10z" />
                            <path d="M5 2.5a.4.4 0 01.392.32l.008.08v1.7h1.7a.4.4 0 01.08.792L7.1 5.4H5.4v1.7a.4.4 0 01-.792.08L4.6 7.1V5.4H2.9a.4.4 0 01-.08-.792L2.9 4.6h1.7V2.9c0-.22.18-.4.4-.4z" />
                        </svg>
                    </span>
                </div>
            </template>

            <template v-if="format === 'estimate'">
                <div class="d-flex justify-content-start align-items-center">
                    <span class="d-inline-block mr-16 slider-label">{{ slider_range[0] }} - {{ slider_range[1] }}{{ slider_range[1] == 300 ? '+' : '' }}</span>
                    <p>{{ translations.participant_amount_popup.persons }}</p>
                </div>

                <span class="d-inline-block"></span>
                <vue-slider v-model="slider_range" :dot-size="24" :tooltip-formatter="tooltipFormat" :interval="5" :min="0" :max="300"></vue-slider>
            </template>
        </div>

        <div class="popup-footer d-flex align-items-center">
            <button class="btn btn-accent btn-sm-100 text-white" @click="submit" v-html="translations.participant_amount_popup.select"></button>
        </div>
    </div>
</template>

<script>
import core from "../day-configurator-core";
import safariFixedBottom from "../../mixins/safari-fixed-bottom";
import { bus } from '@/app';
import { ValidationProvider } from "vee-validate";
var cloneDeep = require('lodash.clonedeep');
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

export default {
    mixins: [core, safariFixedBottom],

    components: { ValidationProvider, VueSlider },

    props: {
        localSchedule: {
            type: Object,
            required: true
        }
    },

    data: () => ({
        format: "estimate",
        exact_value: 20,
        slider_range: [20, 100]
    }),

    created() {
        this.readSchedule();
    },

    methods: {
        readSchedule() {
            if (this.localSchedule.attendee_object != null) {
                if (this.attendee_object != null) {
                    let attendee_object = cloneDeep(this.localSchedule.attendee_object);

                    if (attendee_object.type == "estimate") {
                        this.slider_range[0] = attendee_object.min;
                        this.slider_range[1] = attendee_object.max;
                    } else if (attendee_object.type == "exact") {
                        this.exact_value = attendee_object.amount;
                    }
                }
            }
        },

        submit() {
            bus.$emit('attendeeUpdate', this.createAttendeeObject());
            this.$emit('close');
        },

        setFormat(format) {
            this.format = format;
        },

        increaseParticipants() {
            this.exact_value++;
        },

        decreaseParticipants() {
            if (this.exact_value > 1) this.exact_value--;
        },

        createAttendeeObject() {
            let attendee_object = new Object();
            attendee_object.type = this.format;
            attendee_object.data = new Object();

            if (this.format == "estimate") {
                attendee_object.data.min = this.slider_range[0];
                attendee_object.data.max = this.slider_range[1];
            } else {
                attendee_object.data.amount = this.exact_value;
            }

            return attendee_object;
        },

        tooltipFormat(val) {
            if (val == 300) return '300+'
            return val;
        }
    }
}
</script>